module.exports = __webpack_public_path__ + "static/media/minus-square.5631ab75.svg";